export const Divider = ({ className }: { className?: string }) => (
  <div className={`my-3 h-0.5 w-full bg-primary ${className}`} />
);
